// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d6bc67f4","703":"c090458a","787":"16e13e34"}[chunkId] + ".chunk.js";
};